export default "/images/transfering-codes-active-light.svg?1bbc6787a0be06a5783327ca2c7d4328";